import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import './styles.scss';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faPlus} from '@fortawesome/free-solid-svg-icons';
import strings from 'utils/strings';
import {updateObject} from 'utils/reducerUtils';
import isTrialActive from 'utils/isTrialActive';
import contract from 'assets/Literate_KundeAvtale.pdf';

import {
	ALL,
	NOT_STARTED,
	DISTRIBUTED,
	STARTED,
	COMPLETED,
	TRIAL,
	BASIC,
	ACTIVE,
	STATUS,
} from 'constants/index';
import create from 'assets/create-24px.svg';
import NewTestModal from './NewTestModal';
import TestRow from './TestRow';
import CandidateInfo from './CandidateInfo/CandidateInfo';
import InformationPane from '../../components/InformationPane';

import distributeKey from 'api/distributeKey';
import claimOwnership from 'api/claimOwnerShip';
import softDeleteTest from 'api/softDeleteTest';
import distributeKeyAndStoreInfo from 'api/distributeKeyAndStoreInfo';
import getCorrespondingGroups from 'api/getCorrespondingGroups';
import getTestAdminGroupResults from 'api/getTestAdminGroupResults';
import addCandidatesToClass from 'api/addCandidatesToClass';

import createAdminClass from 'api/createAdminClass';
import addTestToGroup from 'api/addTestToGroup';
import removeTestsFromGroups from 'api/removeTestsFromGroups';
import createTests from 'api/createTests';
import createAndDistributeTests from 'api/createAndDistributeTests';
import createBulkTests from 'api/createBulkTests';

import toggleFeidePortal from 'api/toggleFeidePortal';
import deleteClassMembers from 'api/deleteClassMembers';
import getFilteredTestResults from 'utils/getFilteredTestResults';
import getAllClasses from 'api/getAllClasses';
import getBatchedTestResults from 'utils/getBatchedTestResults';
import getCategorisedTests from 'utils/getCategorisedTests';
import addMomentsToTestResults from 'utils/addMomentsToTestResults';
import addPeriodToTests from 'utils/addPeriodToTests';
import getTestAdminTestResults from 'api/getTestAdminTestResults';
import getTestUsersForTestAdmin from 'api/getTestUsersForTestAdmin';
import renameClass from 'api/renameClass';
import restartTest from 'api/restartTest';
const statusFilters = [
	STATUS,
	ALL,
	NOT_STARTED,
	DISTRIBUTED,
	STARTED,
	COMPLETED,
];

const allMyTests = strings.allmytests;
const defaultExistingKeysForGroup = [];

const processTestResults = (testResults, recentKey) => {
	const testResultsWithStatus = testResults.map((testResult) => {
		let status;
		if (testResult.completedAt) {
			status = COMPLETED;
		} else if (testResult.usedAt && testResult.isUsed) {
			status = STARTED;
		} else if (testResult.distributedAt) {
			status = DISTRIBUTED;
		} else {
			status = NOT_STARTED;
		}

		return updateObject(testResult, {
			status,
		});
	});

	const testResultsWithMoments = addPeriodToTests(testResultsWithStatus);

	const batchedTestResults = getCategorisedTests(testResultsWithMoments);
	return batchedTestResults;
};

class NormingTests extends React.Component {
	constructor() {
		super();

		this.monthRefs = {};

		this.state = {
			activeFilter: ALL,
			isAddingNewTest: false,
			isAddingTestToGroup: false,
			batchedTestResults: null,
			testResults: [],
			selectedGroup: '',
			groupsobject: [],
			groups: [],
			isGroupPanelActive: false,
			groupTests: [],
			grouptests: false,
			adminClasses: [],
			classData: [],
			showPricingInfo: false,
			subscription_id: null,
			userLanguages: null,
			showMyTests: true,
			showMyCandidates: false,
			showMyClasses: false,
			showTestActive: 'tablink1-active',
			showCandidatesactive: 'tablink2',
			showClassesActive: 'tablink3',
			averageZscore: [],
			testUsers: [],
			batchedFilteredTestResults: null,
			existingKeysForGroup: defaultExistingKeysForGroup,
			groupBatchedTestResults: null,
			animator: 'marker-default',
			showInfoPanel: false,
			infoPanelTestKey: null,
			initiatesRedistribution: false,
			paneVariable: null,
			isGroupPoweredByFeide: false,
			chosenGroupProperties: null,
			paneMessage: '',
			initiateSoftDeletion: false,
			renderPaneMessage: false,
			groupedOption: [],
			openTrashCanModel: false,
			deletedTests: [],
			isCandidateDataFirstTimeRendered: true,
			selectedTestStatusOption: '',
			isTestStatusDropDownOpen: false,
			selectedGroupOption: '',
			isGroupDropDownOpen: false,
			activeGroupId: null,
		};
		this.statusDropdownRef = React.createRef();
		this.groupDropdownRef = React.createRef();
		/* this.getTestsReadyForDump = this.getTestsReadyForDump.bind(this); */

		this.getAndSetTestAdminTestResults =
			this.getAndSetTestAdminTestResults.bind(this);
		this.getAndsetTestAdminTestUsers =
			this.getAndsetTestAdminTestUsers.bind(this);
		/* this.getCorrespondingGroups = this.getCorrespondingGroups.bind(this); */
		this.getAndSetTestAdminGroupTestResults =
			this.getAndSetTestAdminGroupTestResults.bind(this);
		this.renderCandidateInfoPanel =
			this.renderCandidateInfoPanel.bind(this);
		this.setStateWithBatchedFilteredResults =
			this.setStateWithBatchedFilteredResults.bind(this);
		/* 
		this.getAndSetUserClasses = this.getAndSetUserClasses.bind(this); */
		this.setUserLanguages = this.setUserLanguages.bind(this);
		this.determineValidSubscription =
			this.determineValidSubscription.bind(this);

		/* this.setLoaderToFalse = this.setLoaderToFalse.bind(this); */
		this.revertIsCandidateDataFirstTimeRendered =
			this.revertIsCandidateDataFirstTimeRendered.bind(this);

		/* this.dumpSingleTest = this.dumpSingleTest.bind(this); */
	}

	componentDidMount() {
		document.addEventListener('click', this.handleClickOutside);

		this.getAndSetTestAdminTestResults().then(() => {
			// if (isFinite(year) && isFinite(month)) {
			// 	const monthBatchKey = `${year}${month}`;
			// 	const monthRef = this.monthRefs[monthBatchKey];
			// 	if (monthRef) {
			// 		monthRef.scrollIntoView(true);
			// 	}
			// }
		});
		this.getAndSetGroupMenu();
		// this.getAndsetTestAdminTestUsers();
		this.getAndSetAdminClasses();
		//window.addEventListener('focus', this.getAndSetTestAdminTestResults);
	}

	componentWillUnmount() {
		window.removeEventListener('focus', this.getAndSetTestAdminTestResults);
		document.removeEventListener('click', this.handleClickOutside);
	}

	handleClickOutside = (event) => {
		if (
			this.statusDropdownRef.current &&
			!this.statusDropdownRef.current.contains(event.target)
		) {
			this.setState({isTestStatusDropDownOpen: false});
		}
		if (
			this.groupDropdownRef.current &&
			!this.groupDropdownRef.current.contains(event.target)
		) {
			this.setState({isGroupDropDownOpen: false});
		}
	};

	reloadPage(time) {
		setTimeout(function () {
			window.location.reload();
		}, time);
	}

	determineValidSubscription(languages) {
		const searchAbaleSubscriptionFields = [
			'norming_child',
			'norming_adult',
			'norming_youth',
		];
		for (let i = 0; i < languages.length; i++) {
			for (const field of searchAbaleSubscriptionFields) {
				if (languages[i][field] !== 0) {
					return false;
				}
			}
		}
		return true;
	}
	revertIsCandidateDataFirstTimeRendered() {
		this.setState({isCandidateDataFirstTimeRendered: false});
	}
	changeTestOwnerShip(testKey) {
		claimOwnership(testKey).then(() => {
			this.getAndSetTestAdminGroupTestResults(
				this.state.selectedGroup,
				false
			);

			this.setState({
				selectedGroup: this.state.selectedGroup,
				isGroupPanelActive: true,
			});
		});
	}

	sendCodeUsingEmail = (id, testKey, emailAddress) => {
		distributeKey(testKey, emailAddress)
			.then((res) => {
				if (res.message) {
					this.setState({
						initiatesRedistribution: false,
						paneMessage: strings.testSentToCandidate,
						renderPaneMessage: true,
					});
				}
			})
			.then(() => {
				const {currentUser} = this.props;
				const id = currentUser.id;
				return getTestAdminTestResults(id, 'isNorming').then(
					(returnArray) => {
						const {testResults = [], deletedKeys = []} =
							returnArray;

						let batchedFilteredTestResults;
						const batchedTestResults = processTestResults(
							testResults,
							testKey
						);

						if (batchedTestResults) {
							batchedFilteredTestResults = getFilteredTestResults(
								batchedTestResults,
								this.state.activeFilter
							);
						}

						return new Promise((resolve) => {
							this.setState(
								{
									testResults,
									batchedTestResults,
									showInfoPanel: false,
									batchedFilteredTestResults:
										batchedFilteredTestResults,
									deletedTests: deletedKeys,
									openTrashCanModel: !deletedKeys.length
										? false
										: this.state.openTrashCanModel,
								},
								resolve
							);
						});
					}
				);
			});
	};
	continueTest(id, testKey) {
		this.setState({
			initiatesRedistribution: true,
			paneVariable: {id, testKey},
			paneMessage: strings.paneMessageContinueTest,
		});
	}
	redistributeContinuedTest(paneVariables) {
		if (paneVariables) {
			restartTest(paneVariables.id, paneVariables.testKey).then((res) => {
				if (res.message) {
					this.setState({
						initiatesRedistribution: false,
						paneMessage: strings.formatString(
							strings.testredistributed,
							<b>{`${res.pinCode}`}</b>
						),
						renderPaneMessage: true,
					});
					const {currentUser} = this.props;
					const id = currentUser.id;

					return getTestAdminTestResults(id, 'isNorming').then(
						(returnArray) => {
							const {testResults = [], deletedKeys = []} =
								returnArray;

							let batchedFilteredTestResults;
							const batchedTestResults = processTestResults(
								testResults,
								null
							);
							if (batchedTestResults) {
								batchedFilteredTestResults =
									getFilteredTestResults(
										batchedTestResults,
										this.state.activeFilter
									);
							}

							return new Promise((resolve) => {
								this.setState(
									{
										testResults,
										batchedTestResults,
										showInfoPanel: false,
										batchedFilteredTestResults:
											batchedFilteredTestResults,
										deletedTests: deletedKeys,
										openTrashCanModel: !deletedKeys.length
											? false
											: this.state.openTrashCanModel,
									},
									resolve
								);
							});
						}
					);
				}
			});
		}
	}

	renderStaticMessagePane(message) {
		this.setState({
			paneMessage: message,
			renderPaneMessage: true,
		});
	}
	renderDynamicMessagePane(message, id, key) {
		this.setState({
			initiateSoftDeletion: true,
			paneVariable: {id, key},
			paneMessage: message,
		});
	}

	softDeleteTest = (returnedProps) => {
		const id = returnedProps.id;
		const testKey = returnedProps.testKey;
		/* e.preventDefault(); */

		softDeleteTest(id, testKey).then(() => {
			this.setState({
				initiateSoftDeletion: false,
				paneMessage: strings.testDeleted,
				renderPaneMessage: true,
			});
			const {currentUser} = this.props;
			const id = currentUser.id;

			return getTestAdminTestResults(id, 'isNorming').then(
				(returnArray) => {
					const {testResults = [], deletedKeys = []} = returnArray;

					let batchedFilteredTestResults;
					const batchedTestResults = processTestResults(
						testResults,
						testKey
					);
					if (batchedTestResults) {
						batchedFilteredTestResults = getFilteredTestResults(
							batchedTestResults,
							this.state.activeFilter
						);
					}

					return new Promise((resolve) => {
						this.setState(
							{
								testResults,
								batchedTestResults,
								showInfoPanel: false,
								batchedFilteredTestResults:
									batchedFilteredTestResults,
								deletedTests: deletedKeys,
								openTrashCanModel: !deletedKeys.length
									? false
									: this.state.openTrashCanModel,
							},
							resolve
						);
					});
				}
			);
		});
	};

	handleFeideGateway(id) {
		let chosenGroupProperties;
		toggleFeidePortal(id).then((results) => {
			const returnArray = results.returnArray;
			chosenGroupProperties = returnArray[0];

			this.setState({
				chosenGroupProperties,
			});
		});
	}

	renderCandidateInfoPanel(testKey, id, pinCode, type) {
		this.setState({
			showInfoPanel: true,
			infoPanelTestKey: {testKey, id, pinCode, type},
		});
	}
	distributeTestWithInfo(
		isNorming,
		testKey,
		testUser,
		excludeReading,
		pinCode
	) {
		if (!testKey || !testUser) {
			return;
		}

		distributeKeyAndStoreInfo(
			isNorming,
			testKey,
			testUser,
			excludeReading,
			pinCode
		)
			.then((res) => {
				if (res.message) {
					const msgText =
						pinCode && pinCode !== 'undefined'
							? strings.formatString(
									strings.candidateInfoSavedTestReadyWithPin,
									pinCode
							  )
							: strings.candidateInfoSavedTestReady;
					this.setState({
						initiatesRedistribution: false,
						paneMessage: msgText,
						renderPaneMessage: true,
					});
				}
			})
			.then(() => {
				const {currentUser} = this.props;
				const id = currentUser.id;
				return getTestAdminTestResults(id, 'isNorming').then(
					(returnArray) => {
						const {testResults = [], deletedKeys = []} =
							returnArray;
						let batchedFilteredTestResults;
						const batchedTestResults = processTestResults(
							testResults,
							testKey
						);

						if (batchedTestResults) {
							batchedFilteredTestResults = getFilteredTestResults(
								batchedTestResults,
								this.state.activeFilter
							);
						}

						return new Promise((resolve) => {
							this.setState(
								{
									testResults,
									batchedTestResults,
									showInfoPanel: false,
									batchedFilteredTestResults:
										batchedFilteredTestResults,
									deletedTests: deletedKeys,
									openTrashCanModel: !deletedKeys.length
										? false
										: this.state.openTrashCanModel,
								},
								resolve
							);
						});
					}
				);
			});
	}

	getAndSetGroupMenu() {
		const {currentUser} = this.props;
		const id = currentUser.id;

		return getCorrespondingGroups(id).then((results) => {
			const groupsobject = results.allGroups;
			const groupedOption = results.groupedOptions;

			return new Promise((resolve) => {
				if (groupsobject.length) {
					const groups = groupsobject.map((groups) => {
						return groups.name;
					});

					this.setState(
						{
							groups,
							selectedGroup: groupsobject[0].id,
							groupsobject,
							groupedOption,
						},
						resolve
					);
				} else {
					this.setState(
						{
							groups: [],
							selectedGroup: '',
						},
						resolve
					);
				}
			});
		});
	}

	async getAndSetTestAdminGroupTestResults(selectedGroup, isFeide) {
		const selectedgroup = selectedGroup;
		if (selectedGroup !== '') {
			const testData = await getTestAdminGroupResults(selectedgroup);
			const {testResults = []} = testData;

			let batchedFilteredTestResults;
			const batchedTestResults = await processTestResults(
				testResults,
				null
			);
			if (batchedTestResults) {
				batchedFilteredTestResults = getFilteredTestResults(
					batchedTestResults,
					this.state.activeFilter
				);
			}
			return await new Promise((resolve) => {
				this.setState(
					{
						testResults,
						batchedTestResults,
						isGroupPanelActive: true,
						batchedFilteredTestResults: batchedFilteredTestResults,
					},
					resolve
				);
			});
		}
		return null;
	}
	getAndSetTestAdminTestResults() {
		const {currentUser} = this.props;
		const id = currentUser.id;

		return getTestAdminTestResults(id, 'isNorming').then((returnArray) => {
			const {testResults = [], deletedKeys = []} = returnArray;
			let batchedFilteredTestResults;
			const batchedTestResults = processTestResults(testResults, null);
			if (batchedTestResults) {
				batchedFilteredTestResults = getFilteredTestResults(
					batchedTestResults,
					this.state.activeFilter
				);
			}

			return new Promise((resolve) => {
				this.setState(
					{
						testResults,
						batchedTestResults,
						showInfoPanel: false,
						batchedFilteredTestResults: batchedFilteredTestResults,
						deletedTests: deletedKeys,
						openTrashCanModel: !deletedKeys.length
							? false
							: this.state.openTrashCanModel,
					},
					resolve
				);
			});
		});
	}

	getAndsetTestAdminTestUsers() {
		return getTestUsersForTestAdmin().then((testUsers) => {
			return new Promise((resolve) => {
				this.setState(
					{
						testUsers,
					},
					resolve
				);
			});
		});
	}
	getAndSetAdminClasses() {
		const {currentUser} = this.props;
		const id = currentUser.id;
		getAllClasses().then((classData) => {
			const adminClasses = classData.map((usersClass) => ({
				className: usersClass.className,
				classId: usersClass.classId,
			}));

			this.setState({
				classData,
				adminClasses,
			});
		});
	}

	setUserLanguages(user) {
		const languages = user.subscription.languages;
		const finalProduct = [];
		const allLanguages = [];
		for (let i = 0; i < languages.length; i++) {
			const languageKey = languages[i].language;
			allLanguages[languageKey] = languages[i];
		}
		finalProduct.push(allLanguages);
		this.setState({userLanguages: finalProduct});
	}

	toggleShowPricingInfo() {
		this.setState({showPricingInfo: !this.state.showPricingInfo});
	}
	getTestKey(selectedKey) {
		this.setState({
			existingKeysForGroup: [
				...this.state.existingKeysForGroup,
				{key: selectedKey},
			],
		});
	}
	removeTestKey(selectedKey) {
		const allTestKeys = this.state.existingKeysForGroup;
		const indexVal = this.findWithProp(allTestKeys, 'key', selectedKey);

		if (indexVal > -1) {
			allTestKeys.splice(indexVal, 1);
			this.setState({
				existingKeysForGroup: allTestKeys,
			});
		}
	}
	findWithProp(array, attr, value) {
		for (let i = 0; i < array.length; i += 1) {
			if (array[i][attr] === value) {
				return i;
			}
		}
		return -1;
	}
	addingTestToGroup(groupId, selectedTests) {
		for (let i = 0; i < selectedTests.length; i++) {
			selectedTests[i].groupId = groupId;
		}

		addTestToGroup(selectedTests).then(() => {
			const alertMessage = strings.formatString(
				strings.selectedTestAddedToGroup,
				`${selectedTests.length > 1 ? strings.testsPluralWord : 'test'}`
			);
			this.getAndSetTestAdminTestResults();

			this.setState({
				isAddingTestToGroup: false,
				existingKeysForGroup: [],
				paneMessage: alertMessage,
				renderPaneMessage: true,
			});
			this.setState({
				showMyTests: false,
				showMyCandidates: true,
				showMyClasses: false,
				showTestActive: 'tablink1',
				showCandidatesactive: 'tablink2-active',
				showClassesActive: 'tablink3',
			});
			this.setState({
				showMyTests: true,
				showMyCandidates: false,
				showMyClasses: false,
				showTestActive: 'tablink1-active',
				showCandidatesactive: 'tablink2',
				showClassesActive: 'tablink3',
			});
		});
	}
	removingTestsFromGroups(selectedTests) {
		removeTestsFromGroups(selectedTests).then(() => {
			const alertMessage = strings.formatString(
				strings.selectedTestRemovedFromGroup,
				`${selectedTests.length > 1 ? strings.testsPluralWord : 'test'}`
			);
			this.getAndSetTestAdminTestResults();
			this.setState({
				isAddingTestToGroup: false,
				existingKeysForGroup: [],
				paneMessage: alertMessage,
				renderPaneMessage: true,
			});
		});
	}
	renderMonth(monthBatch, index) {
		const {testResults} = this.state;

		if (!monthBatch.testResults.length) {
			return null;
		}

		return (
			<div
				className="month"
				key={monthBatch.key}
				ref={(ref) => {
					this.monthRefs[monthBatch.key] = ref;
				}}
			>
				{/* {monthBatch.length === 0 && <p>{strings.nogroupsfound}</p>} */}
				<h3 className="month__heading">{monthBatch.name}</h3>
				<table
					className={
						index === 0 ? 'lit-first-test-table' : 'lit-tests'
					}
				>
					<thead className="lit-tests-thead">
						<tr>
							{/* <td /> */}

							<td className="lit-test__header">
								{strings.status}
							</td>

							<td className="lit-test__header">
								{strings.testkey}
							</td>
							<td className="lit-test__header">{strings.type}</td>
							{this.state.isGroupPanelActive && (
								<td className="lit-test__header">{strings.adminColumnHeader}</td>
							)}
							<td className="lit-test__header">
								{strings.recipient}
							</td>

							<td className="lit-test__header">
								{strings.actions}
							</td>
						</tr>
					</thead>
					<tbody>
						{monthBatch.testResults.map((testResult) => (
							<TestRow
								key={testResult.id}
								processTestResults={processTestResults}
								testResult={testResult}
								testResults={testResults}
								onGettingTestKey={(selectedKey) => {
									return this.getTestKey(selectedKey); //removeTestKey
								}}
								onRemovingTestKey={(selectedKey) => {
									return this.removeTestKey(selectedKey); //removeTestKey
								}}
								groupPanel={this.state.isGroupPanelActive}
								onDelete={this.getAndSetTestAdminTestResults}
								onSoftDelete={
									this.getAndSetTestAdminTestResults
								}
								isSuperAdmin={
									this.props.currentUser.isSuperAdmin
								}
								onDistributeTest={(id, key, email) => {
									this.sendCodeUsingEmail(id, key, email);
								}}
								onClaimOwnership={(testKey) => {
									this.changeTestOwnerShip(testKey);
								}}
								onStartTest={this.getAndSetTestAdminTestResults}
								onContinueTest={(e, id, testKey) => {
									this.continueTest(id, testKey);
								}}
								onshowInfoPanel={(
									testKey,
									id,
									pinCode,
									type
								) => {
									this.renderCandidateInfoPanel(
										testKey,
										id,
										pinCode,
										type
									);
								}}
								onRenderStaticMessagePane={(message) => {
									this.renderStaticMessagePane(message);
								}}
								onRenderDynamicMessagePane={(
									message,
									id,
									key
								) => {
									this.renderDynamicMessagePane(
										message,
										id,
										key
									);
								}}
							/>
						))}
					</tbody>
				</table>
			</div>
		);
	}

	onSaveNewTest = (
		type,
		newTestCount,
		groupId,
		language,
		anamnese,
		childSelfStarting,
		candidateEmails
	) => {
		if (!type) {
			this.setState({
				isAddingNewTest: false,
			});
			return;
		}

		if (!newTestCount) {
			this.setState({
				isAddingNewTest: false,
			});
			return;
		}
		if (!language) {
			this.setState({
				isAddingNewTest: false,
			});
			return;
		}

		const newTestCountInt = parseInt(newTestCount, 10);

		if (!isFinite(newTestCountInt)) {
			return;
		}
		if (candidateEmails) {
			createAndDistributeTests(
				type,
				newTestCountInt,
				groupId,
				language,
				anamnese,
				childSelfStarting,
				candidateEmails,
				'v2'
			).then(() => {
				this.getAndSetTestAdminTestResults();
				this.setState({
					isAddingNewTest: false,
				});
				return true;
			});
		} else {
			createTests(
				type,
				newTestCountInt,
				groupId,
				language,
				anamnese,
				childSelfStarting,
				'v2',
				1
			)
				.then(() => {
					this.getAndSetTestAdminTestResults('', 'isNorming');
					return true;
				})
				.then(() => {
					this.setState({
						isAddingNewTest: false,
					});
				});
		}
	};
	setStateWithBatchedFilteredResults(results) {
		this.setState({getBatchedTestResults: results});
	}
	onSaveNewBulkTest = (
		type,
		newTestCount,
		groupId,
		language,
		testUsers,
		testkeyTypes,
		childSelfStarting
	) => {
		if (!type) {
			this.setState({
				showMyTests: true,
				showMyCandidates: false,
				showMyClasses: false,
				showTestActive: 'tablink1-active',
				showCandidatesactive: 'tablink2',
				showClassesActive: 'tablink3',
			});
			return;
		}

		if (newTestCount !== 1) {
			this.setState({
				showMyTests: true,
				showMyCandidates: false,
				showMyClasses: false,
				showTestActive: 'tablink1-active',
				showCandidatesactive: 'tablink2',
				showClassesActive: 'tablink3',
			});
			return;
		}
		if (!language) {
			this.setState({
				showMyTests: true,
				showMyCandidates: false,
				showMyClasses: false,
				showTestActive: 'tablink1-active',
				showCandidatesactive: 'tablink2',
				showClassesActive: 'tablink3',
			});
			return;
		}

		const newTestCountInt = parseInt(testkeyTypes.length, 10);
		if (!isFinite(newTestCountInt)) {
			return;
		}
		createBulkTests(
			testkeyTypes,
			newTestCountInt,
			groupId,
			language,
			type,
			childSelfStarting
		)
			.then(() => {
				this.getAndSetTestAdminTestResults();
				return true;
			})
			.then(() => {
				this.setState({
					showMyTests: true,
					showMyCandidates: false,
					showMyClasses: false,
					showTestActive: 'tablink1-active',
					showCandidatesactive: 'tablink2',
					showClassesActive: 'tablink3',
					animator: 'marker-default',
				});
			});
	};

	onSelectGroup = (e) => {
		if (e.target.value === allMyTests) {
			this.getAndSetTestAdminTestResults();
			this.setState({
				isGroupPanelActive: false,
			});
		} else {
			const chosenGroup = this.state.groupsobject.filter(
				(groupname) => groupname.name === e.target.value
			);
			const activegroup = chosenGroup[0].id;
			this.getAndSetTestAdminGroupTestResults(activegroup);

			this.setState({
				selectedGroup: chosenGroup[0].id,
				isGroupPanelActive: true,
			});
		}
	};

	onSelectStatus = (statusOption) => {
		this.setState(
			{
				activeFilter: statusFilters.filter(
					(filter) => filter.id === statusOption
				)[0],
			},
			() => {
				let batchedFilteredTestResults;
				const batchedTestResults = processTestResults(
					this.state.testResults,
					null
				);
				if (batchedTestResults) {
					batchedFilteredTestResults = getFilteredTestResults(
						batchedTestResults,
						this.state.activeFilter
					);
				}

				return new Promise((resolve) => {
					this.setState(
						{
							batchedTestResults,
							showInfoPanel: false,
							batchedFilteredTestResults:
								batchedFilteredTestResults,
						},
						resolve
					);
				});
			}
		);
	};

	renderUpgradeBox(isBasicUser, isTrialUser, trialIsActive) {
		return (
			(isTrialUser || isBasicUser) && (
				<div className="lit-new-subscription">
					{isTrialUser && !trialIsActive && (
						<h3 className="lit-new-subscription__header">
							{strings.yourtrialperiodhasexpired}
						</h3>
					)}
					{(isBasicUser || (isTrialUser && trialIsActive)) && (
						<h3 className="lit-new-subscription__header">
							{strings.upgradeyoursubscription}
						</h3>
					)}
					<p className="lit-new-subscription__description">
						{strings.downloadandsendcontract}
						<a
							href="mailto:admin@literate.no"
							target="_blank"
							rel="noopener noreferrer"
						>
							{`admin@literate.no`}
						</a>
						{strings.priceandconditioninfo}
						<a
							href="https://literate.no/pris-og-kjopsbetingelser/"
							target="_blank"
							rel="noopener noreferrer"
						>
							{`https://literate.no/pris-og-kjopsbetingelser/`}
						</a>
					</p>
					<a
						className="lit-btn bg-primary"
						download="Literate_KundeAvtale.pdf"
						href={contract}
					>
						{strings.downloadcontract}
					</a>
				</div>
			)
		);
	}

	toggleTestTypesDropdown = () => {
		this.setState((prevState) => ({
			isTestStatusDropDownOpen: !prevState.isTestStatusDropDownOpen,
		}));
	};

	toggleGroupsDropdown = () => {
		this.setState((prevState) => ({
			isGroupDropDownOpen: !prevState.isGroupDropDownOpen,
		}));
	};

	render() {
		const {currentUser} = this.props;
		const languages = currentUser.subscription.languages;
		const hasInValidSubscription =
			this.determineValidSubscription(languages);

		const {userStage} = currentUser;
		const {
			isAddingNewTest,
			userLanguages,
			selectedTestStatusOption,
			isTestStatusDropDownOpen,
		} = this.state;

		const trialIsActive = isTrialActive(currentUser);
		const isBasicUser = userStage === BASIC;
		const isTrialUser = userStage === TRIAL;
		return (
			<div className="lit-tests--norming-view">
				<nav>
					<div id={this.state.animator}></div>
					<a
						href="#"
						id="defaultOpen"
						onClick={() => {
							this.setState({
								showMyTests: true,
								showMyCandidates: false,
								showMyClasses: false,
								showTestActive: 'tablink1-active',
								showCandidatesactive: 'tablink2',
								showClassesActive: 'tablink3',
								existingKeysForGroup:
									defaultExistingKeysForGroup,
								animator: 'marker-default',
								isGroupPanelActive: false,
							});
							this.getAndSetTestAdminTestResults();
						}}
					>
						{strings.normingTests}
					</a>
				</nav>

				{this.state.showInfoPanel && (
					<CandidateInfo
						closeWindow={() => {
							this.setState({
								showInfoPanel: false,
							});
						}}
						testResults={this.state.testResults}
						processTestResults={processTestResults}
						infoPanelTestKey={this.state.infoPanelTestKey}
						onDistributeTest={this.getAndSetTestAdminTestResults}
						onDistributeKeyAndStoreInfo={(
							isNorming,
							testKey,
							testUser,
							excludeReading,
							pinCode
						) => {
							this.distributeTestWithInfo(
								isNorming,
								testKey,
								testUser,
								excludeReading,
								pinCode
							);
						}}
					/>
				)}
				{this.state.renderPaneMessage && (
					<InformationPane
						paneMessage={this.state.paneMessage}
						onApproval={() => {
							this.setState({
								renderPaneMessage: false,
							});
						}}
						onCloseWindow={() => {
							this.setState({
								renderPaneMessage: false,
							});
						}}
						onDisproval={() => {
							this.setState({
								renderPaneMessage: false,
							});
						}}
						category={'information'}
					/>
				)}
				{this.state.showMyTests && (
					<div className="lit-tests--norming-view__header">
						<div className="lit-new-test__wrapper">
							{isTrialUser && (
								<p>{strings.onlytwotestspertrialperiod}</p>
							)}
							{isBasicUser && (
								<p>{strings.upgradetofullsubscription}</p>
							)}
							<div className="lit-input-tab-grid">
								<button
									className="lit-mytests-header-mytest-btn-primary"
									disabled={
										hasInValidSubscription ||
										isBasicUser ||
										isTrialUser
									}
									onClick={() => {
										this.setUserLanguages(currentUser);
										this.setState({
											isAddingNewTest: true,
											grouptests: false,
										});
									}}
								>
									<FontAwesomeIcon
										className="lit-icon-btns"
										icon={faPlus}
									/>
									<p className="lit-btns-txt">
										{strings.createNormingTest}
									</p>
								</button>

								<div className="lit-View_tests">
									<div
										className="select-container"
										ref={this.statusDropdownRef}
									>
										<div
											className="select-display"
											onClick={
												this.toggleTestTypesDropdown
											}
										>
											{selectedTestStatusOption ||
												statusFilters[1].label}
											<span className="dropdown-arrow">
												▼
											</span>
										</div>
										{isTestStatusDropDownOpen && (
											<div className="dropdown-list">
												{statusFilters.map((option) => (
													<div
														key={option.id}
														className={`dropdown-item ${
															option.label ===
															strings.status
																? 'disabled'
																: ''
														}`}
														onClick={() => {
															this.setState({
																selectedTestStatusOption:
																	option.label,
																isTestStatusDropDownOpen: false,
															});
															if (option.id) {
																this.onSelectStatus(
																	option.id
																);
															}
														}}
													>
														{option.label}
													</div>
												))}
											</div>
										)}
									</div>
								</div>
							</div>

							{isAddingNewTest && (
								<NewTestModal
									onSave={this.onSaveNewTest}
									userStage={userStage}
									userGroups={this.state.groupsobject}
									userLanguages={userLanguages}
									currentUser={this.props.currentUser}
								/>
							)}

							{this.state.initiatesRedistribution && (
								<InformationPane
									paneMessage={this.state.paneMessage}
									variables={this.state.paneVariable}
									onApproval={(returnedProps) => {
										this.redistributeContinuedTest(
											returnedProps
										);
									}}
									onDisproval={() => {
										this.setState({
											initiatesRedistribution: false,
										});
									}}
									onCloseWindow={() => {
										this.setState({
											initiatesRedistribution: false,
										});
									}}
									category={'confirmation'}
								/>
							)}
						</div>
						{this.renderUpgradeBox(
							isBasicUser,
							isTrialUser,
							trialIsActive
						)}
					</div>
				)}
				<p>{strings.followupTestIpadImprovementNotice}</p>
				{this.state.batchedFilteredTestResults &&
					this.state.showMyTests && (
						<div className="lit-tests--norming-view__contant">
							{this.state.batchedFilteredTestResults.length ===
								0 && (
								<p>{strings.no_tests_available_message}</p>
							)}
							{this.state.batchedFilteredTestResults.map(
								(monthBatch, index) =>
									this.renderMonth(monthBatch, index)
							)}
						</div>
					)}

				{/* Scrollers ending div */}
			</div>
		);
	}
}

NormingTests.propTypes = {
	currentUser: PropTypes.shape({}).isRequired,
};

const mapStateToProps = (state) => {
	const {currentUser} = state;

	return {
		currentUser,
	};
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(NormingTests);
